module.exports = __webpack_public_path__ + "assets/icons/ic_rotate_right-5bd4.svg";